/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienLocatorData } from './obrien-locator.data';
import { IObrienLocatorProps } from './obrien-locator.props.autogenerated';

export interface IObrienLocatorViewProps extends IObrienLocatorProps<IObrienLocatorData> {
    obIframe: string;
}

/**
 *
 * ObrienLocator component
 * @extends {React.PureComponent<IObrienLocatorProps<IObrienLocatorData>>}
 */
class ObrienLocator extends React.PureComponent<IObrienLocatorProps<IObrienLocatorData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const ObIframe = config.obIframe ? config.obIframe : 'No Iframe Provided';
        const ObrienLocatorViewProps = {
            ...this.props,
            obIframe: ObIframe,
        };
        return this.props.renderView(ObrienLocatorViewProps);
    }
}

export default ObrienLocator;
